import { Net } from "@buildwithflux/models";
import { pick, uniq } from "lodash";
export function getNetName(terminals, elementsMap, netDesignatorSequencer, allNetNameHints = {}) {
    const isGround = Net.terminalsIncludeGround(Object.keys(terminals), elementsMap);
    if (isGround) {
        // Ground net value
        return "GND";
    }
    // Use the net name hinted by the terminals when there is one unique match
    const netNameHints = pick(allNetNameHints, Object.keys(terminals));
    const uniqueNetNames = uniq(Object.values(netNameHints).filter(Boolean));
    if (uniqueNetNames.length === 1) {
        return uniqueNetNames[0];
    }
    return netDesignatorSequencer.findNextDesignator();
}
//# sourceMappingURL=getNetName.js.map